"use client";
import React, { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";


export const FacebookPixelEvents: React.FC = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const facebookPixelID = process.env.FACEBOOK_PIXEL_ID as string;

  useEffect(() => {
    import("react-facebook-pixel")
      .then((x) => x.default)
      .then((ReactPixel) => {
        ReactPixel.init(facebookPixelID);
        ReactPixel.pageView();
      });
  }, [pathname, searchParams]);

  return null;
};